"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get cleanBaseSchemaCacheForBase () {
        return cleanBaseSchemaCacheForBase;
    },
    get cleanBaseSchemaCacheForWorkspace () {
        return cleanBaseSchemaCacheForWorkspace;
    },
    get getBaseSchema () {
        return getBaseSchema;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getBaseSchema(_context, _ncMeta = _Noco.default.ncMeta) {
// Not Implemented
}
async function cleanBaseSchemaCacheForBase(_baseId) {
// Not Implemented
}
async function cleanBaseSchemaCacheForWorkspace(_workspaceId) {
// Not Implemented
}
